import { totalRecordByDateConstants2 } from "../constant/totalRecord.constants";

export const initialState = {
    dataTotalRecordByDate2: [],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const totalRecordByDateReducer2 = (state = initialState, action) => {
    switch (action.type) {
        case totalRecordByDateConstants2.GET_SUCCESS:
            return {
                ...state,
                dataTotalRecordByDate2: action.totalRecordByDateList2,
                isLoading: true
            };
        case totalRecordByDateConstants2.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        default:
            return state;
    }
};

export default totalRecordByDateReducer2;
